var map = {
	"./arrow-circle-right.svg": 79404,
	"./arrow-right.svg": 98177,
	"./check-circle-white.svg": 12996,
	"./close.svg": 41339,
	"./favicon.ico": 2550,
	"./linkedin-icon.webp": 33373,
	"./mail.svg": 16340,
	"./phone.svg": 83043,
	"./quote.svg": 85079,
	"./user.svg": 30443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60043;